import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class PdfReportService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.pdfReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getReprintRecallPackedItems() {
    const url = this.getFullUrlWithStoreCode(this.envService.reprintRecallPackedItems, null);
    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }

  getReprintRecallReturnReceipt() {
    const url = this.getFullUrlWithStoreCode(this.envService.reprintRecallReturnReceipt, null);
    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}
